import { PageRequest } from '../../types/interfaces';
import IApi from '../api/interfaces/api';
import IApiCalls from '../api/interfaces/apiCalls';

import IBaseService from './interfaces/BaseService';

class BaseService<T> implements IBaseService<T> {
  protected readonly _apiCalls: IApiCalls;
  private readonly _apiTypeField: string;

  constructor(apiCalls: IApiCalls, apiTypeField: string) {
    this._apiCalls = apiCalls;
    this._apiTypeField = apiTypeField;
  }

  addOrUpdate(model: T) {
    const apiCalls = this._apiCalls.beginApiCalls();
    const api = (apiCalls as any)[this._apiTypeField] as IApi<T>;
    return { result: api.addOrUpdate(model), cancel: apiCalls.cancelAllCalls };
  }

  get(id: number) {
    const apiCalls = this._apiCalls.beginApiCalls();
    const api = (apiCalls as any)[this._apiTypeField] as IApi<T>;
    return { result: api.get(id), cancel: apiCalls.cancelAllCalls };
  }

  getAll(pageRequest: PageRequest) {
    const apiCalls = this._apiCalls.beginApiCalls();
    const api = (apiCalls as any)[this._apiTypeField] as IApi<T>;
    return { result: api.getAll(pageRequest), cancel: apiCalls.cancelAllCalls };
  }

  delete(id: number) {
    const apiCalls = this._apiCalls.beginApiCalls();
    const api = (apiCalls as any)[this._apiTypeField] as IApi<T>;
    return { result: api.delete(id), cancel: apiCalls.cancelAllCalls };
  }
}

export default BaseService;
